import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserNoteMiniEntity } from '../../domain/entities/UserNoteMiniEntity'

export class UserNoteMiniModel extends UserNoteMiniEntity {
  constructor(dataDto: UserNoteMiniEntity) {
    super()
    mapEntityProperties<UserNoteMiniModel>(this, dataDto)
  }
}
